module.exports = __webpack_public_path__ + "static/media/Fix.0ff5c25d.svg";